module.exports = __webpack_public_path__ + "img/rights_text.8157a017.png";